import {useDispatch, useSelector} from "react-redux";
import React, {useEffect, useState} from "react";
import LogTable from "../../../primer/LogTable";
import {
    cancelDclEntryPage,
    fetchAdvancedTypesSales,
    postEditDclPage, sendDclToMyData
} from "../../../../_apis/api";
import {
    getAvailableDclNoIssueTypes, getAvailableDclServices,
    getAvailableServiceTypes,
    getOptionsByData,
    isEmpty, validateAFM
} from "../../../../_helpers/commonFunctions";
import moment from "moment/moment";
import {
    setEditDcl,
    setRefreshEditDcl,
    setSelectedDcl,
    setShowDclPageAfterSaleNew
} from "../../../../_reducers/DataPanel/Dcl/dclSlice";
import axios from "axios";
import {toast} from "react-toastify";
import {setCorrelatedDclData} from "../../../../_reducers/DataPanel/Sales/salesSlice";
import {Button, Col, Modal, Row} from "react-bootstrap";
import Alert from "react-bootstrap/Alert";
import {clientServiceTypes} from "../../../../_data/mydata/clientServiceTypes";
import {dclStatusOptions, offSiteProvidedServiceOptions} from "./dclStatusOptions";
import {vehicleCategoryOptions} from "../../../../_data/mydata/vehicleCategoryOptions";
import {vehicleMovementPurposeOptions} from "../../../../_data/mydata/vehicleMovementPurposeOptions";
import Dropdown from "../../../primer/Dropdown";
import Input from "../../../common/Input";
import AdvancedCombobox from "../../../primer/AdvancedCombobox";
import NewClientModal from "../Clients/new-client-modal";
import AccountingBox from "../../../primer/AccountingBox";
import BetterCheckBox from "../../../common/BetterCheckBox";
import TextArea from "../../../common/TextArea";
import CorrelateDclSaleModal from "./CorrelateDclSaleModal";
import {openDCLLocal, openNewSale, openSale} from "../../../../_helpers/tabOpeners";
import {useTranslation} from "../../../../hooks/useTranslation";

const statusClass = (status) => {
    switch (status?.toLowerCase()) {
        case 'open':
            return 'status-open';
        case 'completed':
            return 'status-completed';
        case 'cancelled':
            return 'status-cancel';
        default:
            return '';
    }
}

const EditDcl = () => {
    const dispatch = useDispatch();
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const TABS_DATA = useSelector((state) => state.TABS_REDUCER);
    const companyInstallations = useSelector((state) => state.COMPANY_DATA.companyInstallations);
    const editDclData = useSelector((state) => state.DCL.editDcl);
    const shouldRefreshData = useSelector((state) => state.DCL.refreshEditDcl);
    const SETTINGS = useSelector((state) => state.SETTINGS);
    const dclInstallationDefaultOptions = useSelector((state) => state.SALES_SETTINGS?.salesGeneralSettings?.dclInstallationDefaultOptions);
    const {t} = useTranslation();
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showCorrelatedDclSaleModal, setShowCorrelatedDclSaleModal] = useState(false);
    const [deleteLoader, setDeleteLoader] = useState(false);
    const [updateLoader, setUpdateLoader] = useState(false);
    const [sendToMyDataLoader, setSendToMyDataLoader] = useState(false);
    const [myDataErrorModal, setMyDataErrorModal] = useState(false);
    const [clientsListData, setClientsListData] = useState([]);
    const [installationOptions, setInstallationOptions] = useState([]);
    const documentTypesOptions = [
        {value: "noIssue", label: "Μη Έκδοση Παραστατικού"},
        ...getOptionsByData(SETTINGS.settings.advancedTypesSales?.filter((doc) => doc.mydataProvider === "active" && doc.myDataType !== "11.4" && doc.myDataType !== "5.2" && doc.myDataType !== "5.1"), "_id", "name")];

    const cancelDcl = () => {
        const data = {...editDclData, company: company.id};
        dispatch(cancelDclEntryPage(data, setDeleteLoader, (show) => {
            setShowDeleteModal(show);
        }))
    }

    useEffect(() => {
        if (companyInstallations.length > 0) {
            let options = [];
            companyInstallations.forEach((inst) => {
                options.push({
                    value: inst.installationMasterId,
                    label: inst.type + " " + inst.address + " " + inst.city
                });
            })
            setInstallationOptions(options);
        }
    }, []);

    useEffect(() => {
        if(shouldRefreshData) {
            let reqData = {company: company.id, id: editDclData?._id};
            axios.post(process.env.REACT_APP_API_URL2 + `/dcl/fetch-dcl-by-id`, reqData, {
                headers: {"Content-Type": "application/json"}
            }).then((res) => {
                if (res.data && res.data.status === "200") {
                    if (res.data.data) {
                        dispatch(setEditDcl(res.data.data));
                    }
                }
            }).catch((e) => {
                console.log(e);
            })
            dispatch(setRefreshEditDcl(false));
        }
    }, [shouldRefreshData]);

    useEffect(() => {
        loadClientsListData(null, setClientsListData);
        dispatch(fetchAdvancedTypesSales({company: company.id}));
        if (editDclData) {
            // default options
            let defaultOptions = {...editDclData,
                entryCompletion: true,
                documentType: editDclData?.documentType ? editDclData.documentType : (editDclData?.vehicleMovementPurpose === "2" || editDclData?.vehicleMovementPurpose === "3") ? "noIssue" : "",
                documentTypeName: editDclData?.documentTypeName ? editDclData.documentTypeName : (editDclData?.vehicleMovementPurpose === "2" || editDclData?.vehicleMovementPurpose === "3") ? "Μη Έκδοση Παραστατικού" : "",
                reasonNonIssueType: editDclData?.reasonNonIssueType ? editDclData.reasonNonIssueType : editDclData?.vehicleMovementPurpose === "2" ? "2" : editDclData?.vehicleMovementPurpose === "3" ? "1" : "",
                providedServiceCategory: editDclData?.providedServiceCategory ? editDclData.providedServiceCategory : editDclData?.clientServiceType === "2" ? "7" : editDclData?.clientServiceType === "3" ? "1" : "",
                amount: editDclData?.amount ? editDclData.amount : 0};
            const findInstOptions = dclInstallationDefaultOptions?.find((op) => op.installation === editDclData?.installation);
            if(findInstOptions) {
                if(isEmpty(defaultOptions?.documentType) && !isEmpty(findInstOptions?.documentType)) {
                    defaultOptions.documentType = findInstOptions.documentType;
                    defaultOptions.documentTypeName = findInstOptions.documentTypeName;
                }
                if(isEmpty(defaultOptions?.providedServiceCategory) && isEmpty(defaultOptions?.reasonNonIssueType) && !isEmpty(findInstOptions?.providedServiceCategory)) {
                    if(findInstOptions.providedServiceCategory === "4") {
                        defaultOptions.reasonNonIssueType = "1";
                    } else if(findInstOptions.providedServiceCategory === "6") {
                        defaultOptions.reasonNonIssueType = "3";
                    } else if(findInstOptions.providedServiceCategory === "9") {
                        defaultOptions.reasonNonIssueType = "2";
                    } else {
                        defaultOptions.providedServiceCategory = findInstOptions.providedServiceCategory;
                    }
                }
            }
            dispatch(setEditDcl(defaultOptions));
        }
    }, []);
    const disableFields = editDclData?.status !== "open";
    const clientDropdownColumns = [
        {label: t('SalesNew.clientTable.code'), name: "systemCode"},
        {label: t('SalesNew.clientTable.name'), name: "name"},
        {label: t('SalesNew.clientTable.phone'), name: "phone"},
        {label: t('SalesNew.clientTable.email'), name: "email"},
        {label: t('SalesNew.clientTable.vatNumber'), name: "vatNumber"}
    ];

    const handleOnChange = (e, type = "default", ddname = '') => {
        let name;
        let value;
        if (type === 'dd') {
            value = e.value;
            name = ddname;
        } else if (type === 'dp') {
            value = e ? moment(e).format("DD/MM/YYYY") : "";
            name = ddname;
        } else if (type === "dtb") {
            value = e ? moment(e).toDate() : "";
            name = ddname;
        } else if (type === 'tp') {
            value = e;
            name = ddname;
        } else if (type === 'ac') {
            value = e.target.value;
            name = ddname;
        } else if (type === "acb") {
            if (ddname === "clientName") {
                dispatch(setEditDcl({
                    ...editDclData,
                    client: e.row._id,
                    clientName: e.row.name,
                    clientVatNumber: e.row.vatNumber,
                    clientCountry: e.row.country,
                    clientCategory: e.row.category
                }));
                return;
            } else {
                value = e.target.value;
                name = ddname;
            }
        } else if (type === "cb") {
            value = e.target.checked;
            name = ddname;
        } else if(type === "inputNumber") {
            value = e.target.value.replace(/[^0-9]/g, '');
            name = e.target.name;
        } else {
            value = e.target.value;
            name = e.target.name;
        }
        let editDcl = Object.assign({}, editDclData);
        editDcl[name] = value;
        if (name === "documentType") {
            editDcl.documentTypeName = e.label;
        }
        dispatch(setEditDcl(editDcl));
    }

    const loadClientsListData = (keyword, setData) => {
        let reqData = {company: company.id};
        if (!isEmpty(keyword)) reqData.keyword = keyword;
        if (editDclData?.serviceCategory === "recurring") reqData.onlyWholeshale = true;
        axios.post(process.env.REACT_APP_API_URL2 + `/dcl/dcl-list-client`, reqData, {
            headers: {"Content-Type": "application/json"}
        }).then((res) => {
            if (res.data && res.data.status === "200") {
                if (res.data.data) {
                    let filteredData = res.data.data;
                    if (setData) setData(filteredData);
                } else {
                    if (setData) setData([]);
                }
            } else {
                if (setData) setData([]);
            }
        }).catch((e) => {
            console.log(e);
        })
    }

    const openCorrelatedDcl = () => {
        let reqData = {company: company.id, id: editDclData?.correlatedDclObj};
        axios.post(process.env.REACT_APP_API_URL2 + `/dcl/fetch-dcl-by-id`, reqData, {
            headers: {"Content-Type": "application/json"}
        }).then((res) => {
            if (res.data && res.data.status === "200") {
                if (res.data.data) {
                    dispatch(openDCLLocal(res.data.data, TABS_DATA));
                } else {
                    toast.error("Η συσχετιζόμενη εγγραφή δεν βρέθηκε!");
                }
            } else {
                toast.error("Η συσχετιζόμενη εγγραφή δεν βρέθηκε!");
            }
        }).catch((e) => {
            console.log(e);
        })
    }

    const issueSale = () => {
        dispatch(setCorrelatedDclData(editDclData));
        dispatch(setShowDclPageAfterSaleNew(true));
        dispatch(openNewSale(TABS_DATA));
    }

    const updateDcl = (issueInvoice = false) => {
        let postData = Object.assign({}, editDclData);
        if(isEmpty(postData?.documentType)) {
            return toast.error("Παρακαλώ συμπληρώστε όλα τα απαραίτητα πεδία!");
        } else if(postData?.documentType !== "noIssue" && isEmpty(postData?.offSiteProvidedService) && Number(postData?.amount || 0) === 0) {
            return toast.error("Παρακαλώ συμπληρώστε Συμφωνηθέν ποσό.");
        } else if(postData?.offSiteProvidedService === "1" && isEmpty(postData.cooperatingVatNumber)) {
            return toast.error("Παρακαλώ συμπληρώστε Συνεργαζόμενο Α.Φ.Μ.");
        } else if(postData?.offSiteProvidedService === "2" && isEmpty(postData.otherBranch)) {
            return toast.error("Παρακαλώ συμπληρώστε Άλλη εγκατάσταση");
        }else if(!isEmpty(postData.cooperatingVatNumber) && !validateAFM(postData.cooperatingVatNumber)) {
            return toast.error("Το Συνεργαζόμενο Α.Φ.Μ. είναι λάθος. Παρακαλώ ξαναπροσπαθήστε.");
        } else if(String(postData?.isDiffVehReturnLocation) === "true" && isEmpty(postData?.vehicleReturnLocation)) {
            return toast.error("Παρακαλώ συμπληρώστε Τόπο Επιστροφής Οχήματος");
        }
        postData.company = company.id;
        dispatch(postEditDclPage(postData, setUpdateLoader, issueInvoice, TABS_DATA));
    }

    const handleOpenSale = (saleId) => {
        openSale(dispatch, TABS_DATA, company.id, saleId);
    }

    return (
        <React.Fragment>
            <p className="text-muted mb-2"><i>Στοιχεία Εγγραφής:</i></p>
            {(
                !isEmpty(editDclData?.offlineNewDcl) ||
                !isEmpty(editDclData?.offlineEditDcl) ||
                !isEmpty(editDclData?.offlineCancelDcl) ||
                !isEmpty(editDclData?.offlineCorrelateDcl)
            ) && (
                <Alert variant={"secondary"} style={{padding: "10px"}}>
                    <div style={{fontSize: "13px"}}  className="d-flex justify-content-between">
                                    <span style={{textAlign: 'start'}}>
                                        <span className={"fw-bold"} style={{color: 'red'}}>ΠΡΟΣΟΧΗ! Εκκρεμεί Αποστολή Δεδομένων!</span><br />
                                        {"Ορισμένα δεδομένα δεν έχουν αποσταλεί ακόμη. Το σύστημα έχει ενεργοποιήσει μια αυτοματοποιημένη διαδικασία επαναπροσπάθειας αποστολής.\n" +
                                            "Εάν επιθυμείτε να επιταχύνετε τη διαδικασία, μπορείτε να επιλέξετε 'Αποστολή Τώρα'."}
                                    </span>
                        <span style={{textAlign: 'end'}}>
                                        <Button
                                            disabled={sendToMyDataLoader}
                                            onClick={() => dispatch(sendDclToMyData({company: company.id, id: editDclData?._id}, setSendToMyDataLoader, true))}
                                            variant={"primary"}>
                                            {"Αποστολή Τώρα "}
                                            {sendToMyDataLoader && (<span className="spinner-border spinner-border-sm ml-1" role="status"
                                                                          aria-hidden="true"></span>)}
                                        </Button>
                                    </span>
                    </div>
                </Alert>
            )}
            {editDclData?.myDataEnvironment === "test" && (
                <Alert variant={"secondary"} style={{padding: "10px"}}>
                    <div style={{fontSize: "13px"}}  className="d-flex justify-content-center">
                        <span className={"fw-bold"} style={{color: 'red'}}>ΠΡΟΣΟΧΗ! Η Εγγραφή έχει σταλλεί στο Δοκιμαστικό Περιβάλλον του MyData και θεωρείται ΆΚΥΡΗ!</span><br />
                    </div>
                </Alert>
            )}
            <Row>
                <Col md={6}>
                    <Alert variant={"secondary"}>
                        <div style={{fontSize: "13px"}} className="d-flex justify-content-between">
                            <span style={{textAlign: 'start'}} className={'fw-bold'}>Κωδικός Εγγραφής MyData:</span>
                            <span
                                style={{textAlign: 'end'}}>{editDclData?.dclId}</span>
                        </div>
                        <div style={{fontSize: "13px"}}  className="d-flex justify-content-between fw-bold">
                            <span style={{textAlign: 'start'}}>Ημερομηνία {editDclData?.clientServiceType === "1" ? "Αναχώρησης Οχήματος": "Εισόδου Οχήματος"}:</span>
                            <span
                                style={{textAlign: 'end'}}>{moment(editDclData?.creationDateTime).format("DD/MM/YYYY HH:mm:ss")}</span>
                        </div>
                        {!isEmpty(editDclData?.exitDateTime) && (
                            <div style={{fontSize: "13px"}}  className="d-flex justify-content-between fw-bold">
                                <span style={{textAlign: 'start'}}>Ημερομηνία εξόδου για άλλες εργασίες:</span>
                                <span
                                    style={{textAlign: 'end'}}>{moment(editDclData?.exitDateTime).format("DD/MM/YYYY HH:mm:ss")}</span>
                            </div>
                        )}
                        {!isEmpty(editDclData?.updateDclId) && (
                            <div style={{fontSize: "13px"}}  className="d-flex justify-content-between">
                                <span style={{textAlign: 'start'}} className={'fw-bold'}>Μοναδικός Αρ. Ενημέρωσης Εγγραφής:</span>
                                <span
                                    style={{textAlign: 'end'}}>{editDclData?.updateDclId}</span>
                            </div>
                        )}
                        {!isEmpty(editDclData?.completionDateTime) && (
                            <div style={{fontSize: "13px"}}  className="d-flex justify-content-between fw-bold">
                                <span style={{textAlign: 'start'}}>Ημερομηνία Ολοκλήρωσης και {editDclData?.clientServiceType === "1" ? "Επιστροφής Οχήματος": "Εξόδου Οχήματος"}:</span>
                                <span
                                    style={{textAlign: 'end'}}>{moment(editDclData?.completionDateTime).format("DD/MM/YYYY HH:mm:ss")}</span>
                            </div>
                        )}
                        <div style={{fontSize: "13px"}} className="d-flex justify-content-between">
                            <span style={{textAlign: 'start'}} className={'fw-bold'}>Τύπος Ψηφιακού Πελατολογίου:</span>
                            <span
                                style={{textAlign: 'end'}}>{clientServiceTypes.find((el) => el.value === editDclData?.clientServiceType)?.label}</span>
                        </div>
                        <div style={{fontSize: "13px"}} className="d-flex justify-content-between">
                            <span style={{textAlign: 'start'}} className={'fw-bold'}>Εγκατάσταση:</span>
                            <span
                                style={{textAlign: 'end'}}>{installationOptions.find((el) => el.value === editDclData.installation)?.label}</span>
                        </div>
                        <div style={{fontSize: "13px"}} className="d-flex justify-content-between">
                            <span style={{textAlign: 'start'}} className={'fw-bold'}>Κατάσταση Εγγραφής:</span>
                            <span className={`fw-bold ${statusClass(editDclData.status)}`}
                                  style={{textAlign: 'end'}}>{dclStatusOptions.find((el) => el.value === editDclData.status)?.label}</span>
                        </div>
                        {editDclData?.status === "cancelled" && (
                            <React.Fragment>
                                <div style={{fontSize: "13px"}}  className="d-flex justify-content-between fw-bold">
                                    <span style={{textAlign: 'start'}}>Μοναδικός Αρ. Ακύρωσης Εγγραφής:</span>
                                    <span className={`fw-bold`} style={{textAlign: 'end'}}>{editDclData?.cancelDclId}</span>
                                </div>
                                <div style={{fontSize: "13px"}}  className="d-flex justify-content-between fw-bold">
                                    <span style={{textAlign: 'start'}}>Ημερομηνία Ακύρωσης Εγγραφής:</span>
                                    <span className={`fw-bold`} style={{textAlign: 'end'}}>{moment(editDclData?.cancelDateTime).format("DD/MM/YYYY HH:mm:ss")}</span>
                                </div>
                            </React.Fragment>
                        )}
                        {(editDclData?.serviceCategory === "continuous" || editDclData?.serviceCategory === "continuousLease") && (
                            <React.Fragment>
                                <div style={{fontSize: "13px"}} className="d-flex justify-content-between">
                                    <span style={{textAlign: 'start'}} className={'fw-bold'}>Έναρξη παρεχόμενης υπηρεσίας:</span>
                                    <span style={{textAlign: 'end'}}>{editDclData?.fromAgreedPeriodDate}</span>
                                </div>
                                <div style={{fontSize: "13px"}} className="d-flex justify-content-between">
                                    <span style={{textAlign: 'start'}} className={'fw-bold'}>Λήξη παρεχόμενης υπηρεσίας:</span>
                                    <span style={{textAlign: 'end'}}>{editDclData?.toAgreedPeriodDate}</span>
                                </div>
                            </React.Fragment>
                        )}
                        {isEmpty(editDclData?.periodicity) && (
                            <div style={{fontSize: "13px"}} className="d-flex justify-content-between">
                                <span style={{textAlign: 'start'}} className={'fw-bold'}>Περιοδικότητα Διαρκούς Μίσθωσης/Υπηρεσίας:</span>
                                <span style={{textAlign: 'end'}}>{editDclData?.periodicity}</span>
                            </div>
                        )}
                        {isEmpty(editDclData?.periodicityOther) && (
                            <div style={{fontSize: "13px"}} className="d-flex justify-content-between">
                                <span style={{textAlign: 'start'}} className={'fw-bold'}>Περιοδικότητα Λοιπές:</span>
                                <span style={{textAlign: 'end'}}>{editDclData?.periodicityOther}</span>
                            </div>
                        )}
                        {!isEmpty(editDclData?.correlatedDclId) && (
                            <div style={{fontSize: "13px"}} className="d-flex justify-content-between">
                                <div>
                                    <div style={{textAlign: 'start'}} className={'fw-bold'}>Συσχετιζόμενη
                                        Εγγραφή:
                                    </div>
                                    <div style={{textAlign: 'start'}}>{editDclData?.correlatedDclName}</div>
                                </div>
                                <Button style={{padding: "5px", margin: "5px"}} variant="primary"
                                        onClick={() => openCorrelatedDcl()}>
                                    Εμφάνιση Εγγραφής
                                </Button>
                            </div>
                        )}
                        {!isEmpty(editDclData?.myDataError) && (
                            <div style={{fontSize: "13px"}} className="d-flex justify-content-between align-items-center">
                                <div style={{textAlign: 'start'}} className={'fw-bold'}>
                                    Μήνυμα Λάθους MyData:
                                </div>
                                <Button style={{padding: "5px", marginTop: "5px", alignSelf: "flex-end"}} variant="primary"
                                        onClick={() => setMyDataErrorModal(true)}>
                                    Εμφάνιση Σφάλματος
                                </Button>
                            </div>
                        )}
                    </Alert>
                </Col>
                <Col md={6}>
                    <Alert variant={"secondary"}>
                        <div style={{fontSize: "13px"}} className="d-flex justify-content-between">
                            <span style={{textAlign: 'start'}} className={'fw-bold'}>Πινακίδα Οχήματος:</span>
                            <span
                                style={{textAlign: 'end'}}>{`${editDclData?.vehicleCountry} ${editDclData?.vehicleRegistrationNumber}`}</span>
                        </div>
                        <div style={{fontSize: "13px"}} className="d-flex justify-content-between">
                            <span style={{textAlign: 'start'}} className={'fw-bold'}>Κατηγορία Οχήματος:</span>
                            <span
                                style={{textAlign: 'end'}}>{vehicleCategoryOptions.find((el) => el.value === editDclData.vehicleCategory)?.label}</span>
                        </div>
                        <div style={{fontSize: "13px"}} className="d-flex justify-content-between">
                            <span style={{textAlign: 'start'}} className={'fw-bold'}>Μοντέλο Οχήματος:</span>
                            <span style={{textAlign: 'end'}}>{editDclData?.vehicleFactory}</span>
                        </div>
                        <div style={{fontSize: "13px"}} className="d-flex justify-content-between">
                            <span style={{textAlign: 'start'}} className={'fw-bold'}>Κατηγορία Υπηρεσίας:</span>
                            <span
                                style={{textAlign: 'end'}}>{getAvailableServiceTypes(editDclData?.clientServiceType).find((el) => el.value === editDclData.serviceCategory)?.label}</span>
                        </div>
                        {editDclData?.mixedService === "true" && (
                            <div style={{fontSize: "13px"}} className="d-flex justify-content-between">
                                <span style={{textAlign: 'start'}} className={'fw-bold'}>Μικτή Υπηρεσία:</span>
                                <span style={{textAlign: 'end'}}>Ναί</span>
                            </div>
                        )}
                        {editDclData?.clientServiceType === "1" && (
                            <React.Fragment>
                                <div style={{fontSize: "13px"}} className="d-flex justify-content-between">
                                    <span style={{textAlign: 'start'}} className={'fw-bold'}>Σκοπός Κίνησης Οχήματος:</span>
                                    <span
                                        style={{textAlign: 'end'}}>{vehicleMovementPurposeOptions.find((el) => el.value === editDclData.vehicleMovementPurpose)?.label}</span>
                                </div>
                                {editDclData?.isDiffVehPickupLocation === "true" && (
                                    <div style={{fontSize: "13px"}} className="d-flex justify-content-between">
                                        <span style={{textAlign: 'start'}} className={'fw-bold'}>Τόπος Παραλαβής Οχήματος:</span>
                                        <span
                                            style={{textAlign: 'end'}}>{editDclData?.vehiclePickupLocation}</span>
                                    </div>
                                )}
                            </React.Fragment>
                        )}
                    </Alert>
                </Col>
            </Row>
            <hr style={{marginTop: "0", marginBottom: "0.3rem"}}/>
            <p className="text-muted mb-2"><i>Στοιχεία Παραστατικού:</i></p>
            <Row>
                <Col sm={12} md={4}>
                    <Dropdown
                        label={t('SalesNew.DocumentType')}
                        key={Math.random()}
                        required={true}
                        disabled={disableFields}
                        name="documentType"
                        options={documentTypesOptions}
                        defaultValue={documentTypesOptions.find((el) => el.value === editDclData.documentType)}
                        onChange={(e) => handleOnChange(e, 'dd', 'documentType')}
                    />
                </Col>
                {editDclData?.documentType === "noIssue" ? (
                    <Col md={4}>
                        <Dropdown
                            label={"Αιτιολογία Μη έκδοσης Παραστατικού"}
                            key={Math.random()}
                            disabled={disableFields}
                            required={true}
                            name="reasonNonIssueType"
                            options={getAvailableDclNoIssueTypes(editDclData?.clientServiceType)}
                            defaultValue={getAvailableDclNoIssueTypes(editDclData?.clientServiceType).find((el) => el.value === editDclData.reasonNonIssueType)}
                            onChange={(e) => handleOnChange(e, 'dd', 'reasonNonIssueType')}
                        />
                    </Col>
                ) : (
                    <React.Fragment>
                        {editDclData?.clientServiceType !== "1" && (
                            <Col md={4}>
                                <Dropdown
                                    label={"Κατηγορία Παρεχόμενων Υπηρεσιών"}
                                    key={Math.random()}
                                    required={true}
                                    disabled={disableFields}
                                    name="providedServiceCategory"
                                    options={getAvailableDclServices(editDclData?.clientServiceType)}
                                    defaultValue={getAvailableDclServices(editDclData?.clientServiceType).find((el) => el.value === editDclData.providedServiceCategory)}
                                    onChange={(e) => handleOnChange(e, 'dd', 'providedServiceCategory')}
                                />
                            </Col>
                        )}
                        {editDclData?.providedServiceCategory === "5" && (
                            <Col md={4}>
                                <Input
                                    label={"Περιγραφή Κατηγορίας Παρεχόμενων Υπηρεσιών Λοιπά"}
                                    name={"providedServiceCategoryOther"}
                                    charLimit={100}
                                    disabled={disableFields}
                                    placeholder={"Εισάγετε Περιγραφή Κατηγορίας"}
                                    type={"text"}
                                    required={true}
                                    value={editDclData?.providedServiceCategoryOther}
                                    onChange={(e) => handleOnChange(e, "input", "providedServiceCategoryOther")}
                                />
                            </Col>
                        )}
                    </React.Fragment>
                )}
            </Row>
            <Row>
                <Col md={8}>
                    <div className="d-flex justify-content-between">
                        <AdvancedCombobox
                            name={"clientName"}
                            className={"w-100 ac-select-dropdown flex-grow-1"}
                            defaultValue={`${editDclData.clientName}${editDclData.clientVatNumber ? ` (${editDclData.clientVatNumber})` : ""}`}
                            label={"Πελάτης"}
                            data={clientsListData}
                            disabled={disableFields}
                            onChange={(e) => handleOnChange(e, "acb", "clientName")}
                            key={editDclData.client}
                            onChangeSearch={(keyword, setData) => loadClientsListData(keyword, setData)}
                            excludeColumns={[]}
                            columns={clientDropdownColumns}
                            deleteEnable={false}
                            searchTableEnable={false}
                            showTableOptionOnSelect={true}
                            placeholder={"Πληκτρολογήστε και επιλέξτε πελάτη"}
                            required={true}
                            showInsertAddButton={true}
                            hideSaveButton={true}
                            hideInsertNewRow={true}
                            inputFieldClasses="form-control"
                        />
                        {editDclData?.client ? (
                            <button disabled={disableFields} className="btn quick-retail-clientbtn btn-default btn-sm ml-1 mt-4"
                                    title="Clear Client" key={Math.random()}
                                    onClick={() => dispatch(setSelectedDcl({
                                        ...editDclData,
                                        client: "",
                                        clientName: "",
                                        clientVatNumber: "",
                                        clientCountry: "",
                                        clientCategory: ""
                                    }))}><i className="fas fa-xmark"></i></button>
                        ) : (
                            <div className={'ml-1'} style={{paddingTop: "23px"}}>
                                <NewClientModal
                                    fromPrescription={false}
                                    successCallback={(data) => dispatch(setSelectedDcl({
                                        ...editDclData,
                                        client: data._id,
                                        clientName: data.name,
                                        clientVatNumber: data.vatNumber,
                                        clientCountry: data.country,
                                        clientCategory: data.category
                                    }))}/>
                            </div>
                        )}
                    </div>
                </Col>
                <Col md={4}>
                    <div style={{marginBottom: "5px"}}>Συμφωνηθέν Ποσό <span className="text-danger"> *</span>
                    </div>
                    <AccountingBox
                        name="amount"
                        disabled={disableFields}
                        className="form-control"
                        placeholder={"Εισάγετε Συμφωνηθέν Ποσό"}
                        defaultValue={editDclData?.amount}
                        key={`amount ${editDclData?._id}`}
                        onBlur={(e) => handleOnChange(e, 'ac', 'amount')}
                    />
                </Col>
            </Row>
            {(editDclData?.clientServiceType === "1" || editDclData?.clientServiceType === "3") && (
                <React.Fragment>
                    <hr style={{marginTop: "0", marginBottom: "0.3rem"}}/>
                    <p className="text-muted" style={{marginBottom: "0"}}><i>Λοιπές Ενέργειες:</i></p>
                </React.Fragment>
            )}
            {editDclData?.clientServiceType === "3" && (
                <Row>
                    <Col md={5}>
                        <Dropdown
                            label={"Παροχή Υπηρεσιών εκτός Εγκατάστασης"}
                            key={Math.random()}
                            disabled={disableFields}
                            name="offSiteProvidedService"
                            options={offSiteProvidedServiceOptions}
                            defaultValue={offSiteProvidedServiceOptions.find((el) => el.value === editDclData?.offSiteProvidedService)}
                            onChange={(e) => handleOnChange(e, 'dd', 'offSiteProvidedService')}
                        />
                    </Col>
                    {editDclData?.offSiteProvidedService === "2" ? (
                        <Col md={4}>
                            <Dropdown
                                name={"otherBranch"}
                                label={"Άλλη Εγκατάσταση εντός της ίδιας οντότητας"}
                                defaultValue={companyInstallations.filter((inst) => inst.value !== editDclData?.installation)?.find((el) => el.value === editDclData?.otherBranch)}
                                key={Math.random()}
                                required={true}
                                disabled={disableFields}
                                className={"w-100 mb-2"}
                                options={companyInstallations.filter((inst) => inst.value !== editDclData?.installation)}
                                onChange={(e) => handleOnChange(e, 'dd', 'otherBranch')}
                            />
                        </Col>
                    ) : (editDclData?.offSiteProvidedService === "1") ? (
                        <Col md={4}>
                            <Input
                                disabled={disableFields}
                                label={"Συνεργαζόμενο ΑΦΜ"}
                                name={"cooperatingVatNumber"}
                                placeholder={"Εισάγετε Συνεργαζόμενο ΑΦΜ"}
                                type={"text"}
                                required={true}
                                value={editDclData?.cooperatingVatNumber}
                                onChange={(e) => handleOnChange(e, "inputNumber", "cooperatingVatNumber")}
                            />
                        </Col>
                    ) : ""}
                </Row>
            )}
            {editDclData?.clientServiceType === "1" && (
                <React.Fragment>
                    <BetterCheckBox
                        disabled={disableFields}
                        className={"mb-0"}
                        name={"isDiffVehReturnLocation"}
                        text={"Διαφορετικός Τόπος Επιστροφής Οχήματος"}
                        checked={String(editDclData?.isDiffVehReturnLocation) === "true" || false}
                        onChange={(e) => handleOnChange(e, 'cb', 'isDiffVehReturnLocation')}
                    />
                    {String(editDclData?.isDiffVehReturnLocation) === "true" && (
                        <Col md={5}>
                            <Input
                                disabled={disableFields}
                                label={"Τόπος Επιστροφής Οχήματος"}
                                name={"vehicleReturnLocation"}
                                charLimit={250}
                                placeholder={"Εισάγετε Τόπο Επιστροφής Οχήματος"}
                                type={"text"}
                                required={true}
                                value={editDclData?.vehicleReturnLocation}
                                onChange={(e) => handleOnChange(e, "input", "vehicleReturnLocation")}
                            />
                        </Col>
                    )}
                </React.Fragment>
            )}
            {editDclData?.correlatedSales?.length > 0 && (
                <React.Fragment>
                    <hr style={{marginTop: "0", marginBottom: "0.3rem"}}/>
                    <p className="text-muted mb-2"><i>Συσχετιζόμενα Παραστατικά:</i></p>
                    <Row style={{overflowX: "auto"}}>
                        <Col md={12}>
                            <table className={"simpleClassicTable mb-2"} style={{width: "100%", tableLayout: "auto", wordBreak: "normal"}}>
                                <colgroup>
                                    <col span={1} style={{width: "10%"}}></col>
                                    <col span={1} style={{width: "15%"}}></col>
                                    <col span={1} style={{width: "20%"}}></col>
                                    <col span={1} style={{width: "10%"}}></col>
                                    <col span={1} style={{width: "10%"}}></col>
                                    <col span={1} style={{width: "8.5%"}}></col>
                                    <col span={1} style={{width: "8.5%"}}></col>
                                </colgroup>
                                <thead>
                                <tr>
                                    <th>Μοναδικός Αρ. Συσχέτισης</th>
                                    <th>Ημερομηνία Έκδοσης</th>
                                    <th>Τύπος Παραστατικού</th>
                                    <th>Αρίθμηση</th>
                                    <th>Τρόπος Πληρωμής</th>
                                    <th>Πληρωτέο Ποσό</th>
                                    <th>Εμφάνιση</th>
                                </tr>
                                </thead>
                                <tbody>
                                {editDclData.correlatedSales.map((row, idx) => (
                                    <tr key={`rppa-${idx}`}>
                                        <td>{row.correlateId}</td>
                                        <td>{row.saleName.split("|")[4].trim()}</td>
                                        <td>{row.saleName.split("|")[0].trim()}</td>
                                        <td>{row.saleName.split("|")[1].trim()}</td>
                                        <td>{row.saleName.split("|")[2].trim()}</td>
                                        <td>{row.saleName.split("|")[3].trim()}</td>
                                        <td><Button style={{padding: "5px", margin: "2px"}} variant="primary" onClick={() => handleOpenSale(row.saleId)}>
                                            Εμφάνιση Πώλησης
                                        </Button></td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </Col>
                    </Row>
                </React.Fragment>
            )}
            <Row>
                <Col md={12}>
                    <div className={"text-muted mb-2"}><i>Σημειώσεις Εγγραφής</i></div>
                    <TextArea
                        disabled={disableFields}
                        name={"comments"}
                        rows={"4"}
                        limit={150}
                        placeholder={"Εισάγετε Σημειώσεις Εγγραφής"}
                        value={editDclData?.comments ? editDclData?.comments : ""}
                        onChange={(e) => handleOnChange(e, 'default', 'comments')}
                    />
                </Col>
            </Row>
            <Row className={"mb-1"}>
                <Col md={3}>
                    <div className={`d-flex justify-content-start align-items-center gap-2 flex-wrap ${editDclData?.status === "open" ? "mt-2" : "mt-0"}`}>
                        <Button hidden={editDclData?.status === "cancelled"}  variant="outline-danger"
                                onClick={() => setShowDeleteModal(true)}>
                            Ακύρωση Εγγραφής
                        </Button>
                    </div>
                </Col>
                <Col md={9}>
                <div className="d-flex justify-content-end align-items-center gap-2 flex-wrap">
            {editDclData?.status === "open" ? (
                <React.Fragment>
                    <div style={{paddingTop: "25px"}}>
                        <BetterCheckBox
                            disabled={disableFields}
                            name={"entryCompletion"}
                            text={editDclData?.clientServiceType === "1" ? "Επιστροφή Οχήματος" : "Έξοδος Οχήματος"}
                            checked={String(editDclData?.entryCompletion) === "true"}
                            onChange={(e) => handleOnChange(e, 'cb', 'entryCompletion')}
                        />
                    </div>
                    <Button disabled={disableFields || updateLoader} variant="primary" onClick={() => updateDcl()}>
                        Ενημέρωση
                        {updateLoader && (<span className="spinner-border spinner-border-sm ml-1" role="status"
                                                aria-hidden="true"></span>)}
                    </Button>
                    {editDclData?.documentType !== "noIssue" && (
                        <Button disabled={disableFields || updateLoader} variant="primary" onClick={() => updateDcl(true)}>
                            Ενημέρωση και Έκδοση Παραστατικού
                            {updateLoader && (<span className="spinner-border spinner-border-sm ml-1" role="status"
                                                    aria-hidden="true"></span>)}
                        </Button>
                    )}
                </React.Fragment>
            ) : (
                <React.Fragment>
                    <Button hidden={editDclData?.status === "cancelled"} variant="primary" onClick={() => setShowCorrelatedDclSaleModal(true)}>
                        Συσχέτιση με Υπάρχων Παραστατικό
                        {updateLoader && (<span className="spinner-border spinner-border-sm ml-1" role="status" aria-hidden="true"></span>)}
                    </Button>
                    <Button hidden={editDclData?.status === "cancelled"} variant="primary" onClick={() => issueSale()}>
                        Έκδοση Παραστατικού
                        {updateLoader && (<span className="spinner-border spinner-border-sm ml-1" role="status" aria-hidden="true"></span>)}
                    </Button>
                </React.Fragment>
            )}
                </div>
                </Col>
            </Row>

            <CorrelateDclSaleModal show={showCorrelatedDclSaleModal} setShow={setShowCorrelatedDclSaleModal} dcl={editDclData} />

            <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Ακύρωση Εγγραφής</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Προσοχή! Η Ακύρωση Εγγραφής θα αποσταλεί στο MyData. Είστε σίγουρος ότι θέλετε να συνεχίσετε?
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-primary" onClick={() => setShowDeleteModal(false)}>
                        Κλείσιμο
                    </Button>
                    <Button disabled={deleteLoader} variant="primary" onClick={() => cancelDcl()}>
                        Ακύρωση Εγγραφής
                        {deleteLoader && (<span className="spinner-border spinner-border-sm ml-1" role="status"
                                                aria-hidden="true"></span>)}
                    </Button>
                </Modal.Footer>
            </Modal>
            <Modal backdrop={"static"} className="themeModal" show={myDataErrorModal}>
                <Modal.Header>
                    <Modal.Title>Προσοχή!</Modal.Title>
                </Modal.Header>
                <Modal.Body>Η αποστολή της εγγραφής στο MyData απέτυχε! <br /> Το μήνυμα λάθους είναι: <br /> {editDclData?.myDataError}</Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-primary" onClick={() => setMyDataErrorModal(false)}>Εντάξει</Button>
                </Modal.Footer>
            </Modal>
        </React.Fragment>
    )
}

export default EditDcl;

export const DclEditLog = () => {
    const {t} = useTranslation();
    const dcl = useSelector((state) => state.DCL.editDcl);
    return (
        <React.Fragment>
            <div className="text-muted mb-2"><i>{t('Logs.workMovementLog')}</i></div>
            <LogTable itemId={dcl._id}/>
        </React.Fragment>
    )
}
